import styled from 'styled-components';
import Spacer from 'components/Spacer';
import { Heading } from 'components/Typography';
import { getThemeColor } from 'utils/styled';

export const Root = styled(Spacer)`
  background-color: ${getThemeColor('l2')};
  padding: 20px 30px;
  width: 260px;
  text-align: center;
`;

export const Header = styled(Heading)`
  overflow-wrap: anywhere;
`;
